import { computed, type ComputedRef } from 'vue'
import { useOverviewStore } from '../../stores/overview'

interface UseButtonScrolldown {
  disabled: ComputedRef<boolean>
  doScrollDown: Function
}

//------------------------------------------------
export function useButtonScrolldown(): UseButtonScrolldown {
  const overviewStore = useOverviewStore()

  const disabled = computed(() => !overviewStore.hasScrolldown)

  function doScrollDown() {
    overviewStore.slideDown()
  }

  return {
    disabled,
    doScrollDown,
  }
}

//------------------------------------------------
export function useButtonScrolldownMock(): UseButtonScrolldown {
  const disabled = computed(() => false)

  function doScrollDown() {
    console.debug('doScrollDown()')
  }

  return {
    disabled,
    doScrollDown,
  }
}
